export const normalizeSkillName = (value?: string) => value?.trim().toLowerCase() ?? ''

export const dedupeSkills = <T extends { name: string }>(skills: T[]): T[] => {
  const seen = new Set<string>()

  return skills.filter((skill) => {
    const normalizedName = normalizeSkillName(skill.name)

    if (!normalizedName || seen.has(normalizedName)) {
      return false
    }

    seen.add(normalizedName)
    return true
  })
}
